import styled from 'styled-components';

export const InfiniteScrollInnerWrapper = styled.div`
    display: flex;
    white-space: nowrap;
    align-items: center;

    & > * {
        transition: 1s linear;
    }
`;

export const InfiniteScrollOuterWrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    overflow: hidden;

    & > ${InfiniteScrollInnerWrapper} {
        animation: scroll 60s linear infinite;
        animation-delay: calc(60s * -1);
    }

    & > ${InfiniteScrollInnerWrapper}:nth-child(2) {
        animation: scroll2 60s linear infinite;
        animation-delay: calc(60s / -2);
    }

    @keyframes scroll {
        0% {
            transform: translateX(100%);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    @keyframes scroll2 {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(-200%);
        }
    }
`;
